 <!-- Jumbotron -->
 <div class="page-header header-filter mt-0 mb-0" style="background-image: url('assets/img/smallbusiness.jpg')">
    <div class="container">
      <div class="row">
        <div class="col-md-8 ml-auto mr-auto">
          <div class="brand text-center">
            <h1>RegScale for Small to Medium Business (SMB)</h1>
            <h3 class="title text-center">Bringing Enterprise-Class Solutions to the Small Business Community</h3>
              <a href="https://go.regscale.com/RegScale-Create-Account" class="btn btn-rose btn-raised btn-round ">
               Get Started
             </a>
          </div>
        </div>
      </div>
    </div>
  </div>
 
<!--    Introducting RegScale      -->
<div class="features-3" style="background-color: white;">
    <div class="row align-items-center">
      <div class="col-md-6">
        <div class="text-center">
          <img class="img-fluid" style="width: 80%;" src="./assets/img/status-board.PNG">
        </div>
      </div>
      <div class="col-md-6">
        <!-- Some <br /> tags to push the text to align with the image, you can remove it if you have more text on the right side :-) -->
        <h2 class="title" style="color: #00b5e2">Minimizing Compliance Costs for Small Businesses</h2>
        <h4>You are never too small to start reducing your compliance risks.  As a small business, we realize that legal fees, compliance documentation, and audit costs can bust the budget so we developed RegScale to help lower the cost of compliance for all businesses - large or small.</h4>
            <a href="https://go.regscale.com/RegScale-Create-Account" class="btn btn-rose btn-raised btn-round mt-4">
                Get Started
              </a>
      </div>
    </div>
   </div>
 
    <!--     *********     Common Use Cases     *********      -->
    <div class="features-5">
      <div class="col-md-8 ml-auto mr-auto text-center">
        <h2 class="title">Common Customer Use Cases</h2>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-sm-4">
            <div class="info">
              <div class="icon">
                <i class="fas fa-clipboard-check fa-2x"></i>
              </div>
              <h4 class="info-title">Audits/Assessments</h4>
              <p>Manage your audit/assessment program schedule and leverage our APIS for a real-time view into your compliance status to avoid embarrassing non-compliances that result in increased regulator involvement. </p>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="info">
              <div class="icon">
                <i class="far fa-times-circle fa-2x"></i>
              </div>
              <h4 class="info-title">Issues Management</h4>
              <p>Track the status of non-compliance problems, conduct causal analysis, and track corrective actions to closure to pro-actively prevent recurrence of issues.
              </p>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="info">
              <div class="icon">
                <i class="fas fa-shield-alt fa-2x"></i>
              </div>
              <h4 class="info-title">Cyber Security</h4>
              <p>Quickly build FISMA, CMMC, and other cyber security plans using our simple wizard to lower the cost of generating compliance documentation and ensure you are able to keep your contracts.
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="info">
              <div class="icon">
                <i class="fas fa-bug fa-2x"></i>
              </div>
              <h4 class="info-title">Quality Assurance</h4>
              <p>Schedule and track inspections to improve product or service quality, capture defects and track corrective actions, and manage quality certification processes such as ISO 9001. </p>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="info">
              <div class="icon">
                <i class="fas fa-dollar-sign fa-2x"></i>
              </div>
              <h4 class="info-title">Predictable Costs</h4>
              <p>Get started for free with our Community Edition (CE) or leverage our Enterprise Edition (EE) platform for predictable pricing where you can cancel anytime.</p>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="info">
              <div class="icon">
                <i class="fas fa-file-signature fa-2x"></i>
              </div>
              <h4 class="info-title">Contract Management</h4>
              <p>Ensure contractual obligations are met by tracking requirement status and assessing compliance over time to avoid compliance issues that can delay payments or void your contracts.</p>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="info">
              <div class="icon">
                <i class="fas fa-book fa-2x"></i>
              </div>
              <h4 class="info-title">Policy Management</h4>
              <p>Draft and publish policies, track review and comment processes through disposition, build approval workflows, and capture requirements for formal tracking of compliance to improve the lifecycle management of policies and to better track implementation. </p>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="info">
              <div class="icon">
                <i class="fas fa-paste fa-2x"></i>
              </div>
              <h4 class="info-title">Documentation</h4>
              <p>Compliance documentation is expensive and time consuming to create.  We provide a TurboTax like experience for quickly creating your documentation.</p>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="info">
              <div class="icon">
                <i class="fas fa-cloud fa-2x"></i>
              </div>
              <h4 class="info-title">Managed Service</h4>
              <p>Leverage our turn-key, secure hosting solution where you have no infrastructure to manage, no capital costs, and no in-house IT support is required.  </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Cyber Use Case -->
    <div class="section section-text">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto">
            <h2 class="title text-center" style="color: #00b5e2; padding-bottom: 50px;">RegScale in Action: SMB Compliance</h2>
            <div class="card">
                <div class="card-header card-header-icon card-header-danger">
                  <div class="card-icon">
                    <h3><i class="fas fa-exclamation-circle"></i> What's the Problem?</h3>
                  </div>
                </div>
                <div class="card-body">
                    <h4 class="card-title">SMB Compliance Requirements</h4>
                    <p>Small businesses are not exempt from federal, state, and local compliance regulations though they often lack the expertise and financial resources to achieve and maintain compliance over time.</p>
            
                    <p>Areas of concern are numerous and include (non-exhaustive list): 1) Human Resources (HR), 2) Taxes, 3) Safety, 4) Security, and 5) Payroll.</p>
                </div>
            </div>
          </div>
        </div>
        <div class="row">
            <div class="col-md-8 ml-auto mr-auto">
              <div class="card">
                  <div class="card-header card-header-icon card-header-danger">
                    <div class="card-icon">
                      <h3><i class="fas fa-chart-line"></i> How Big is the Problem?</h3>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="card card-nav-tabs">
                                <div class="card-header card-header-danger text-center">
                                  Federal Compliance Costs
                                </div>
                                <div class="card-body text-center">
                                  <p class="card-text">According to the Small Business Administration (SBA), small companies spend up to 80% more per employee on federal regulatory compliance than large companies.</p>
                                </div>
                              </div>
                        </div>
                        <div class="col-md-4">
                            <div class="card card-nav-tabs">
                                <div class="card-header card-header-danger text-center">
                                  Litigation
                                </div>
                                <div class="card-body text-center">
                                  <p class="card-text">Wrongful termination lawsuits average $85k in legal costs with winning plaintiffs receiving an average of $500,000.</p>
                                </div>
                              </div>
                        </div>
                        <div class="col-md-4">
                            <div class="card card-nav-tabs">
                                <div class="card-header card-header-danger text-center">
                                  Financial Errors
                                </div>
                                <div class="card-body text-center">
                                  <p class="card-text">32% of small businesses had a payroll compliance error last year with 42% not understanding basic compliance requirements such as FICA.</p>
                                </div>
                              </div>
                        </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        <div class="row">
            <div class="col-md-8 ml-auto mr-auto">
              <div class="card">
                  <div class="card-header card-header-icon card-header-success">
                    <div class="card-icon">
                      <h3><i class="far fa-check-circle"></i> How Do We Help?</h3>
                    </div>
                  </div>
                  <div class="card-body">
                      <div class="row">
                          <div class="col-md-4">
                            <div class="info info-horizontal">
                                <div class="icon icon-success">
                                    <i class="fas fa-check-circle"></i>
                                </div>
                                <div class="description">
                                    <h4 class="info-title">Simple and Intuitive</h4>
                                    <p>Use an intuitive wizard (Next->Next->Finish) to rapidly build compliance documentation</p>
                                </div>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="info info-horizontal">
                                <div class="icon icon-success">
                                    <i class="far fa-calendar"></i>
                                </div>
                                <div class="description">
                                    <h4 class="info-title">Schedule and Automate</h4>
                                    <p>Plan your assessment schedule and manage both manual and automated compliance checks against your controls leveraging our APIs</p>
                                </div>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="info info-horizontal">
                                <div class="icon icon-success">
                                    <i class="fas fa-clipboard-list"></i>
                                </div>
                                <div class="description">
                                    <h4 class="info-title">Track</h4>
                                    <p>Track your compliance against checklists to minimize your compliance risk.</p>
                                </div>
                            </div>
                          </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="info info-horizontal">
                              <div class="icon icon-success">
                                <i class="fas fa-book"></i>
                              </div>
                              <div class="description">
                                  <h4 class="info-title">Catalogues</h4>
                                  <p>Access to a free and growing library of checklists to assist you in validating your compliance</p>
                              </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="info info-horizontal">
                              <div class="icon icon-success">
                                <i class="fas fa-tv"></i>
                              </div>
                              <div class="description">
                                  <h4 class="info-title">Compliance Workbench</h4>
                                  <p>Monitor and manage all of your assigned compliance activities in a single pane of glass</p>
                              </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="info info-horizontal">
                              <div class="icon icon-success">
                                <i class="fas fa-chart-bar"></i>
                              </div>
                              <div class="description">
                                  <h4 class="info-title">Reporting and Visualization</h4>
                                  <p>Real-time visualizations and reporting on the state of compliance across all systems in your own compliance cloud</p>
                              </div>
                          </div>
                        </div>
                    </div>
                  </div>
              </div>
            </div>
        </div>
          <div class="row">
            <div class="col-md-8 ml-auto mr-auto">
              <div class="card">
                  <div class="card-header card-header-icon card-header-primary">
                    <div class="card-icon">
                      <h3><i class="far fa-handshake"></i> What Can RegScale Do For You?</h3>
                    </div>
                  </div>
                  <div class="card-body">
                      <p>RegScale is purpose-built to be deployed anywhere, whether on premises, in your own cloud instance, or consumed as a fully Managed Service.   As a vendor-neutral compliance cloud, you can manage requirements across multiple frameworks and dynamically output compliance information in a format or visualization that works for you and your customer.  Management can monitor key performance indicators regarding the state of compliance across the entire enterprise, updated in real-time using automated assessments, bringing DevOps to Compliance.</p>
              
                      <p>Compliance as a platform, with a wide array of tightly integrated modules that work better together, and available as a FREE Community Edition.  Free yourself from bureaucracy today leveraging our intuitive solution to simplify compliance.</p>
                  
                      <div class="text-center">
                        <a href="https://go.regscale.com/RegScale-Create-Account" class="btn btn-rose btn-raised btn-round mt-4">
                          Get Started
                        </a>
                      </div>
                    </div>
              </div>
            </div>
          </div>
    </div>
 
    <!-- Contact Us -->
    <app-contact-us></app-contact-us>
 


